import { useQuery } from '@tanstack/react-query'
import { queryKeys } from '../config/queryKeys'
import { getTeamRosters } from '../services/team/teamRosters'
import type { Roster } from '../types/Roster'

const EMPTY_ROSTERS: Roster[] = []

interface UseTeamRostersOptions {
  teamId?: string | null
  enabled?: boolean
}

/**
 * Every roster (one per season) of a team — GET /teams/:id/rosters, cached under
 * one key so the Registration tab's Season picker and its Billing sub-tab share a
 * single fetch.
 */
const useTeamRosters = ({ teamId, enabled = true }: UseTeamRostersOptions) => {
  const query = useQuery<Roster[]>({
    queryKey: queryKeys.teamRosters.byTeam(teamId),
    queryFn: () => getTeamRosters(teamId as string),
    enabled: Boolean(teamId) && enabled,
    staleTime: 30_000,
  })

  const rosters: Roster[] = query.data ?? EMPTY_ROSTERS

  return { ...query, rosters }
}

export default useTeamRosters
